import api from '../api';
import translate from '../core/tools/translate';
import ShapesInfo from './ShapesInfo';
import { FeaturePermission } from '../../constants/feature.permission.helper';

const isAuthorized = (permission, feature) => api.authorization.isAuthorized(permission, feature);
const LayerControls = (name) => require('../controls').get(name);

class SelectedAreasInfo extends ShapesInfo {
    constructor () {
        const name = 'SelectedAreas';

        const options = {
            layer: LayerControls(name).getLayer(),
            label: translate(`Common.${name}`),
            name: name,
            id: 'area-selection',
            context: 'area-selection'
        };

        super(options);

        this.getType = this.getType.bind(this);
    }

    static getInstance () {
        if (!SelectedAreasInfo._instance) {
            SelectedAreasInfo._instance = new SelectedAreasInfo();
        }

        return SelectedAreasInfo._instance;
    }

    _hasActions () { return false; }

    _hasSummary () {
        return isAuthorized(FeaturePermission.INFO_SUMMARY.show);
    }

    getType () {
        return LayerControls(this.options.name).get().scheme();
    }
}

export default SelectedAreasInfo;



// WEBPACK FOOTER //
// ./src/scripts/info/SelectedAreasInfo.js